const mediaItems = [
  {
    tag: '热门视频',
    title: '独家揭秘：娱乐圈新人出道背后的资本推手全解析',
    duration: '12:36',
    views: '89万',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20video%20thumbnail%20style%20abstract%20illustration%20with%20warm%20crimson%20and%20golden%20spotlight%20effects%2C%20dramatic%20stage%20lighting%20with%20bokeh%20background%2C%20modern%20media%20player%20aesthetic%2C%20clean%20professional%20composition%2C%20atmospheric%20entertainment%20industry%20visual&width=800&height=450&seq=media-01&orientation=landscape',
    platform: '专题视频',
  },
  {
    tag: '访谈',
    title: '资深娱记讲述从业二十年见过的最大反转事件',
    duration: '18:22',
    views: '56万',
    img: 'https://readdy.ai/api/search-image?query=Interview%20studio%20atmosphere%20abstract%20illustration%20with%20warm%20amber%20and%20crimson%20tones%2C%20professional%20microphone%20and%20soft%20studio%20lighting%2C%20modern%20podcast%20aesthetic%2C%20clean%20minimal%20composition%2C%20atmospheric%20depth&width=800&height=450&seq=media-02&orientation=landscape',
    platform: '人物访谈',
  },
  {
    tag: '动画',
    title: '三分钟看懂娱乐圈常见的十种公关套路',
    duration: '03:15',
    views: '128万',
    img: 'https://readdy.ai/api/search-image?query=Colorful%20motion%20graphics%20style%20abstract%20illustration%20with%20warm%20crimson%20and%20golden%20gradient%2C%20animated%20explainer%20video%20aesthetic%2C%20clean%20geometric%20shapes%20and%20icons%2C%20modern%20educational%20content%20design%2C%20playful%20yet%20professional&width=800&height=450&seq=media-03&orientation=landscape',
    platform: '科普动画',
  },
  {
    tag: '纪录片',
    title: '网红江湖：从素人到顶流的真实成长路径全纪录',
    duration: '25:48',
    views: '73万',
    img: 'https://readdy.ai/api/search-image?query=Documentary%20style%20abstract%20illustration%20with%20warm%20golden%20amber%20and%20soft%20crimson%20tones%2C%20timeline%20visual%20narrative%20with%20milestone%20markers%2C%20modern%20documentary%20film%20aesthetic%2C%20clean%20professional%20composition%2C%20atmospheric%20storytelling%20visual&width=800&height=450&seq=media-04&orientation=landscape',
    platform: '纪录短片',
  },
  {
    tag: '盘点',
    title: '年度十大令人震惊的娱乐圈事件现场画面回顾',
    duration: '08:50',
    views: '201万',
    img: 'https://readdy.ai/api/search-image?query=Countdown%20style%20abstract%20illustration%20with%20warm%20crimson%20and%20golden%20gradient%2C%20number%20rankings%20visual%20design%20with%20dramatic%20lighting%2C%20modern%20list%20format%20aesthetic%2C%20clean%20editorial%20composition%2C%20atmospheric%20entertainment%20vibe&width=800&height=450&seq=media-05&orientation=landscape',
    platform: '年度盘点',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            媒体聚焦
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            视频专题、深度访谈与动画科普，多维度呈现吃瓜资讯
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaItems.map((item, idx) => (
            <a
              key={idx}
              href="#media"
              className="group block bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200/70 transition-all cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/15 group-hover:bg-black/25 transition-colors"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-500/85 text-background-50 group-hover:bg-primary-500 group-hover:scale-110 transition-all">
                    <i className="ri-play-fill text-xl md:text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-3">
                  <span className="inline-block px-2 py-0.5 bg-black/60 text-background-50 text-xs rounded-md whitespace-nowrap">
                    {item.duration}
                  </span>
                </div>
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 bg-accent-500/85 text-background-50 text-xs font-semibold rounded-md whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>{item.platform}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}